import React from "react";
import arrow from "../assets/images/sidom/fotos/FlechaenCirc4.png"; // Adjust the path as necessary

export default function CardBeneficios({
  titulo,
  descripcion,
  backgroundColor,
  textcolor,
}) {
  return (
    <div>
      <div className="  flex items-center     justify-center">
        <div className={` container ${backgroundColor} ${textcolor} `}>
          <div className=" flex items-end  w-[100%]   dark:text-sidom-light  justify-start  gap-2">
            <div className="flex-shrink-0 w-10 h-10 bg-orange-500 rounded-full flex items-center justify-center">
              <img src={arrow} className="  text-lg font-bold" alt="Flecha" />
            </div>
            <div>
              <h3 className="text-3xl  leading-[1.3] font-bold ">{titulo}</h3>
            </div>
          </div>
          <div className=" flex items-center  leading-[1.3] mb-[30px]  justify-end   gap-2">
            <p className=" text-lg  pr-10 w-[80%] md:w-[80%]  mt-1">
              {descripcion}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
